import React, { Component } from 'react'
import { connect } from 'react-redux'
import SettingMenu from '../../../../constants/menu/setting'
import { Link, withRouter } from 'react-router-dom'
import { scCategoryService, settingGSTItemService } from '../../../../services'
import { authService } from '../../../../services'

// UI
import { Button, Loading, Page, Pager, Panel, SideModal, List } from '../../../../components'
import { Permissions } from '../../../../constants'
import Form from 'antd/lib/form'
import Switch from 'antd/lib/switch'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Select from 'antd/lib/select'
import Skeleton from 'antd/lib/skeleton'
import Popconfirm from 'antd/lib/popconfirm'
import message from 'antd/lib/message'

import './styles.css'
import notify from '../../../../components/Notification'

import { auth, formatter, validator } from '../../../../util'

const pageSize = 20
const { Item: FormItem } = Form
const Option = Select.Option

const setType = 'sc-cats'
const setTitle = 'Category'

export class SettingRateCategories extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentPage: 1,
      filter: {},
      isItemEditable: false,
      isShowModal: false,
      list: [],
      loading: false,
      loadingForm: false,
      searchText: '',
      sort: {},
      selectedItem: {},
      total: 0,
      taxCodeList: []
    }
  }

  componentDidMount () {
    this.fetchTaxCodeList()
    this.refreshList()
  }

  fetchTaxCodeList = async () => {
    if (!this.hasAccess(Permissions.SETTING.RATESETS.LIST)) return

    try {
      const settings = await settingGSTItemService.getAll()

      if (validator.isNotEmptyArray(settings)) {
        this.setState({ taxCodeList: settings })
      }
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load settings successfully. Please try again later.')
    }
  }

  refreshList = () => {
    const { currentPage } = this.state
    this.fetchList({ currentPage })
  }

  fetchList = async ({ currentPage = 1, filter = {}, sort = {}, searchText }) => {
    if (!this.hasAccess(Permissions.SETTING.CATS.LIST)) return

    try {
      this.setState({ currentPage, loading: true })

      const settings = await scCategoryService.listByPage(currentPage, pageSize)

      this.setState({ list: settings.list, loading: false, total: settings.total })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load settings successfully. Please try again later.')
    }
  }

  showModal = (item = {}) => {
    const isItemEditable = !!this.hasAccess(Permissions.SETTING.CATS.UPDATE) && (!item.id || item.id && item.is_editable === true)
    this.setState({ isShowModal: true, isItemEditable, selectedItem: item })
  }

  hideModal = () => {
    const { form } = this.props

    this.setState({ isShowModal: false, isItemEditable: false, selectedItem: {} }, () => {
      form.resetFields()
    })
  }

  async handleDelete (id) {
    this.setState({ loading: true })
    const res = await scCategoryService.remove(id)

    if (res && res.id) {
      notify.success('Deleted successfully', `${formatter.capitalize(setTitle)} deleted successfully.`)
    } else {
      notify.error('Unable to delete successfully', `Unable to delete ${setTitle} successfully. Please try again later.`)
    }

    this.refreshList()
  }

  handleSave = () => {
    const { form, match } = this.props
    const { validateFields } = form
    const { selectedItem } = this.state

    validateFields(async (errors, values) => {
      if (!errors) {
        try {
          this.setState({ loadingForm: true })

          const body = {
            name: values.name,
            identifier: values.identifier,
            tax_code_id: values.tax_code_id,
            active: values.active
          }

          let r = null
          if (selectedItem.id) {
            r = await scCategoryService.save(selectedItem.id, body)
          } else {
            r = await scCategoryService.add(body)
          }

          if (r && r.id) {
            notify.success('Saved successfully', `${setTitle} saved successfully.`)
            this.refreshList()
            this.hideModal()
          } else {
            notify.error('Unable to save successfully', `Unable to save ${setTitle} successfully. Please try again later.`)
          }

          this.setState({ loadingForm: false })
        } catch (e) {
          this.setState({ loadingForm: false })
          notify.error('Unable to save successfully', `Unable to save ${setTitle} successfully. Please try again later.`)
        }
      }
    })
  }

  hasAccess (accessLevel) {
    return auth.hasAccess(accessLevel)
  }

  findOption (input, option) {
    const p = option.props.children

    return p.toLowerCase().indexOf(input.toLowerCase()) > -1
  }

  render () {
    const { currentPage, isShowModal, isItemEditable, list, loading, loadingForm, selectedItem, total, taxCodeList } = this.state
    const { form } = this.props
    const { getFieldDecorator } = form

    const columns = [
      {
        title: 'Name',
        width: 11,
        render: ({ id, name }) => <div>{name}</div>
      },
      {
        title: 'Item Number',
        width: 5,
        render: ({ identifier }) => <div>{identifier}</div>
      },
      {
        title: 'Tax Code',
        width: 3,
        render: ({ id, tax_code_name }) => <div>{tax_code_name}</div>
      },
      {
        title: 'Enable',
        width: 3,
        render: ({ active }) => <div style={{ color: active ? '#4fbc85' : '#ccc', fontSize: '11pt' }}><Icon type='check-circle' theme='filled' /></div>
      },
      {
        title: '',
        width: 1,
        render: (item) => (
          this.hasAccess(Permissions.SETTING.CATS.READ) && !this.hasAccess(Permissions.SETTING.CATS.UPDATE)
          ? <div style={{cursor: 'pointer'}} onClick={() => this.showModal(item)}><Icon type='eye' /></div>
          : this.hasAccess(Permissions.SETTING.CATS.UPDATE)
            ? <div style={{cursor: 'pointer'}} onClick={() => this.showModal(item)}><Icon type='form' /></div>
            : null
        )
      },
      {
        title: '',
        width: 1,
        render: ({ id, is_editable }) => this.hasAccess(Permissions.SETTING.CATS.DELETE) && is_editable
        ? <Popconfirm
          title='Confirm to delete this?'
          onConfirm={(e) => this.handleDelete(id)}
          okText='Yes'
          cancelText='No'
          >
            <Icon type='delete' />
          </Popconfirm>
        : null
      }
    ]

    return (
      <div>
        <div className='setting-list'>
          <Skeleton loading={loading} active>
            <div className='header-action'>
              { this.hasAccess(Permissions.SETTING.CATS.LIST)
                ? <div className='btn btn-ghost' onClick={() => this.fetchList({ currentPage: 1 })}>
                  {`Refresh`}
                </div>
                : null }
              { this.hasAccess(Permissions.SETTING.CATS.CREATE)
                ? <div className='btn' onClick={() => this.showModal()}>
                  {`Add ${setTitle}`}
                </div>
                : null }
            </div>

            <List cols={columns} rows={list} />

            <Pager
              size={pageSize}
              total={total}
              totalText={`Total ${total} Categor${total === 1 ? 'y' : 'ies'}`}
              current={currentPage}
              onChange={this.changePage}
              style={{ marginTop: '15px' }}
            />
          </Skeleton>

          <SideModal
            title={`${setTitle}`}
            showModal={isShowModal}
            onClose={this.hideModal}
            buttons={[
              <Button key='save' onClick={this.handleSave} feedback={loadingForm}>Save</Button>
            ]}
          >
            <Loading loading={loadingForm} blur>
              <Form layout='vertical'>
                <FormItem label='Category Name'>
                  {getFieldDecorator('name', {
                    initialValue: selectedItem.name,
                    rules: [
                      { required: true, message: 'Please enter category name' },
                      { whitespace: true, message: 'Please enter category name' }
                    ]
                  })(
                    <Input disabled={!isItemEditable}/>
                  )}
                </FormItem>
                <FormItem label='Category Item Number'>
                  {getFieldDecorator('identifier', {
                    initialValue: selectedItem.identifier,
                    rules: [
                      { required: true, message: 'Please enter category identifier' },
                      { whitespace: true, message: 'Please enter category identifier' }
                    ]
                  })(
                    <Input placeholder='Enter NDIS Support Item Number' disabled={!isItemEditable}/>
                  )}
                </FormItem>
                <FormItem label='Tax Code'>
                  {getFieldDecorator('tax_code_id', {
                    initialValue: selectedItem.tax_code_id,
                    rules: [
                      { required: true, message: 'Please select tax code' }
                    ]
                  })(
                    <Select showSearch
                      style={{ width: '100%'}}
                      optionFilterProp='children'
                      notFoundContent='Not found'
                      filterOption={(input, option) => this.findOption(input, option)}
                    >
                      { taxCodeList.map((c, idx) => {
                          return <Option key={`trxx${idx}`} value={c.id}>
                            { c.name }
                          </Option>

                        })}
                    </Select>
                  )}
                </FormItem>
                <FormItem label=''>
                  {getFieldDecorator('active', {
                    initialValue: selectedItem.active !== undefined ? selectedItem.active : true,
                    valuePropName: 'checked'
                  })(
                    <Switch
                      disabled={loadingForm}
                      checkedChildren='Enable'
                      unCheckedChildren='Disable'
                    />
                  )}
                </FormItem>
              </Form>
            </Loading>
          </SideModal>
        </div>
      </div>
    )
  }

  changePage = (currentPage) => {
    const { filter, searchText, sort } = this.state
    this.fetchList({ loading: true, currentPage, filter, sort, searchText })
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(withRouter(SettingRateCategories)))
